// Tipos de "Medio de difusión" (el rol interno sigue llamándose "productor").
//
// Antes esta lista estaba copiada a mano en el registro y en las dos
// pantallas del perfil del difusor; agregar un tipo en una y olvidarlo en
// otra dejaba al difusor sin poder volver a elegir el suyo al editar.
//
// Influencer, Youtuber y Streamer viven acá y no entre los tipos de
// ecosistema musical: su perfil difunde música de terceros, no la propia.
export const TIPOS_DIFUSOR = [
  "Blog de música",
  "Revista",
  "Periódico",
  "Estación de radio",
  "Canal de TV",
  "Influencer",
  "Youtuber",
  "Streamer",
];
